// extracted by mini-css-extract-plugin
module.exports = {"side-projects":"SideProjects_side-projects__1o1kX","side-projects_list":"SideProjects_side-projects_list__3pUou","sideProjectsItem":"SideProjects_sideProjectsItem__cM2ZU"};